import { requestBuilder } from '../../http/RequestBuilder';
import type { BankingAdoption } from '../types/BankingAdoption';

const getBankingAdoption = requestBuilder.query<BankingAdoption>({
    endpoint: `/api/banking-adoption`,
    queryKey: `getBankingAdoption`,
});

const useGetBankingAdoption = ({
    enabled = true,
}: { enabled?: boolean } = {}) => {
    return getBankingAdoption(
        {},
        {
            enabled,
            staleTime: 0,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
        },
    );
};

export default useGetBankingAdoption;
